import {
  Flex,
  IconButton,
  useBreakpointValue,
  WrapItem,
} from "@chakra-ui/react";

import { Large, P } from "../components/Type";

import GopayIcon from "../assets/gopay.png";
import OvoIcon from "../assets/ovo.png";
import DanaIcon from "../assets/dana.png";
import LinkAjaIcon from "../assets/linkaja.png";
import QrisIcon from "../assets/qris.png";
import ShopeePayIcon from "../assets/shopeepay.png";
import PayMayaIcon from "../assets/maya.png";
import GCashIcon from "../assets/gcash.png";
import GrabPayIcon from "../assets/grabpay.png";
import WechatPayIcon from "../assets/wechatpay.png";
import AlipayIcon from "../assets/alipay.png";
import CreditCardIcon from "../assets/credit_card.png";
import LinePayIcon from "../assets/linepay.png";
import PaypayIcon from "../assets/paypay.png";
import RakutenPayIcon from "../assets/rakutenpay.png";
import MerpayIcon from "../assets/merpay.png";
import Image from "next/image";
import { usePaymentMethodSelector } from "../contexts/paymentMethodSelector";
import { Trans } from "@lingui/macro";
import { VENDOR_CUT, isQrisVendorCutFree } from "../utils";
import { useUserInfo } from "../hooks/useUserInfo";
import BCAVAIcon from "../assets/bca.png";
import MandiriVAIcon from "../assets/mandiri.png";
import BRIVAIcon from "../assets/bri.png";
import BNIVAIcon from "../assets/bni.png";
import PermataVAIcon from "../assets/permata.png";
import BJBVAIcon from "../assets/bjb.png";
import BSIVAIcon from "../assets/bsi.png";
import CIMBVAIcon from "../assets/cimb.png";


const ICON_MAP = {
  // IDR
  gopay: GopayIcon,
  ovo: OvoIcon,
  dana: DanaIcon,
  linkaja: LinkAjaIcon,
  qris: QrisIcon,
  // PHP
  shopeepay: ShopeePayIcon,
  gcash: GCashIcon,
  paymaya: PayMayaIcon,
  grabpay: GrabPayIcon,
  // JPY
  // TODO: add the alipay later
  linepay: LinePayIcon,
  alipay: AlipayIcon,
  paypay: PaypayIcon,
  rakutenpay: RakutenPayIcon,
  merpay: MerpayIcon,
  // Universal
  wechat_pay: WechatPayIcon,
  inter_cc: CreditCardIcon,

  bca: BCAVAIcon,
  mandiri: MandiriVAIcon,
  bri: BRIVAIcon,
  bni: BNIVAIcon,
  permata: PermataVAIcon,
  bjb: BJBVAIcon,
  bsi: BSIVAIcon,
  cimb: CIMBVAIcon,

};

const VA_TYPES = new Set(["bca", "mandiri", "bri", "bni", "permata", "bjb", "cimb", "bsi"]);

const PaymentButton = ({
  enabled,
  type,
  pressed,
  color = "green",
  backgroundColor = "saweria-green.normal",
  disabled = false,
  onClick,
  "data-testid": dataTestId,
  props,
}) => {
  const isMobile = useBreakpointValue([true, false]);
  if (!enabled) {
    return null;
  }

  const { selectedPaymentMethod, transactionFeePolicy, transactionAmount, pgFee } = usePaymentMethodSelector();
  // backend fee is the source of truth once this payment method is selected
  const isBackendCharged = selectedPaymentMethod == type && Number(pgFee) > 0;
  const vendorCutLabel = isQrisVendorCutFree(type, transactionAmount) && !isBackendCharged ? "0%" : VENDOR_CUT[type];
  return (
    <WrapItem flexGrow={1} >
      <IconButton
        _hover={{}}
        _active={{}}
        _disabled={{
          cursor: "not-allowed",
        }}
        w="100%"
        m={0}
        h="80px"
        filter={disabled ? "grayscale(75%)" : ""}
        transform={pressed ? "translate(0.1rem, 0.1rem)" : ""}
        transition="box-shadow .1s , transform .2s "
        disabled={disabled}
        onClick={onClick}
        color={color}
        backgroundColor={backgroundColor}
        border="1px solid black"
        borderRadius="md"
        {...props}
        boxShadow={
          disabled || pressed || selectedPaymentMethod == type
            ? "pressed"
            : "buttonRaised"
        }
        data-testid={dataTestId}
      >
        {VA_TYPES.has(type) ? (
          <Flex position="relative" w="100%" h="100%" paddingLeft={5} paddingBottom={3}>
            <Image
              src={ICON_MAP[type]}
              objectFit="contain"
              placeholder="blur"
              width={88}
              height={27}
              style={{ position: 'absolute', left: '19.2px', top: '21.5px' }}
            />
            {transactionFeePolicy == 'TIPPER' && (
              <Large
                position="absolute"
                left="38px"
                top="53px"
                marginBottom={0}
                fontSize={["xs"]}
                fontWeight="600"
                lineHeight="25px"
              >
                {vendorCutLabel}
              </Large>
            )}
          </Flex>
        ) : (
          <Flex flexDirection="column" justifyContent="space-between" h="100%">
            <Flex justifyContent="center" alignItems="center" flex={1}>
              <Image
                src={ICON_MAP[type]}
                objectFit="contain"
                placeholder="blur"
                layout="fill"
                style={{ height: "1px", width: "auto" }}
                height={0}
              />
            </Flex>
            {transactionFeePolicy == 'TIPPER' &&
              <Large pt={10} marginBottom={0} paddingBottom={1} fontSize={["xs"]}>
                {vendorCutLabel}
              </Large>
            }
          </Flex>
        )}
      </IconButton>
    </WrapItem>
  );
};

export { PaymentButton };
